import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';
import type {
  RejectFlowStep,
  RejectReasonOption,
} from './models/reject-flow.model';

@Component({
  selector: 'app-reject-call-dialog',
  standalone: true,
  imports: [LocalizationPipe],
  templateUrl: './reject-call-dialog.component.html',
  styleUrl: './reject-call-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RejectCallDialogComponent {
  readonly step = input<RejectFlowStep>('idle');
  readonly selectedReason = input<string | null>(null);
  readonly reasonOptions = input<readonly RejectReasonOption[]>([]);
  /**
   * The decline reasons are still loading. Locks the affirmative action only — Cancel stays live so
   * the agent is never trapped in a modal they cannot close (cancelling mid-load is safe: the shared
   * flow service tears the request down).
   */
  readonly busy = input(false);
  /** Caller name or number, shown so the agent keeps that context while the modal covers the toast. */
  readonly callerLabel = input<string | null>(null);

  readonly dismiss = output<void>();
  readonly proceedToReasonSelection = output<void>();
  readonly selectReason = output<string>();
  readonly confirmReject = output<void>();

  onCancel(): void {
    this.dismiss.emit();
  }

  onProceedToReasonSelection(): void {
    this.proceedToReasonSelection.emit();
  }

  onSelectReason(reason: string): void {
    this.selectReason.emit(reason);
  }

  onConfirmReject(): void {
    this.confirmReject.emit();
  }
}
